import { useMutateMPEFetch } from '@retail/app/hooks';
import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { useAuthContext } from '@retail/auth/data-access';
import { mpeApi } from '@retail/mgpris/config';
import { buildUrl } from '@shared/utils';

interface Props {
  assortmentId: number;
}

export function useSetNonStockSupplier({ assortmentId }: Props) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMutateMPEFetch<undefined>({
    token,
    method: 'POST',
    url: (supplierId) =>
      buildUrl({
        base: mpe.url,
        route: mpeApi.suppliers.supplier.nonStockItemSupplier.assortment.getFullLinkPath({
          supplierId,
          assortmentId,
        }),
      }),
  });
}

export function useDeleteNonStockSupplier({ assortmentId }: Props) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMutateMPEFetch<undefined>({
    token,
    method: 'DELETE',
    url: (supplierId) =>
      buildUrl({
        base: mpe.url,
        route: mpeApi.suppliers.supplier.nonStockItemSupplier.assortment.getFullLinkPath({
          supplierId,
          assortmentId,
        }),
      }),
  });
}
